<template>
  <div class="home">
    
    <ResumenEdit/>
    
  </div>
</template>

<script>
// @ is an alias to /src
import ResumenEdit from '@/components/ResumenEdit.vue'

export default {
  name: 'resumenParteEdit',
  components: {
    ResumenEdit,
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
</style>
